


















import Component from 'vue-class-component'
import Vue from 'vue'
import { Prop } from 'vue-property-decorator'
import RespondecoSearchResultItem from '@/shared/components/respondeco-search-result-item.vue'
import { SearchResultItem } from '@/shared/models/search-result-item'

@Component({
  name: 'respondeco-search-results',
  components: { RespondecoSearchResultItem },
})
export default class RespondecoSearchResults extends Vue {
  @Prop({
    required: true,
    type: String,
  })
  public readonly callToAction!: string

  @Prop({
    required: true,
    type: Array,
  })
  public readonly items!: SearchResultItem

  @Prop({
    required: true,
    type: String,
  })
  public readonly route!: string
}
